import { Environment } from "../app/models/env.model";

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api-turnos-dev.municipiodurango.gob.mx/api',
  usuario: "modulo@test.com",
  password: "test",
  multimediaBaseUrl: "https://d2o0vwsbnldsgl.cloudfront.net",
  playlistPath: "playlists/lobby-1/playlist.json"
};
